
export default  {
    bind: function(el, binding, vnode) {
        el.clickExclude = function(event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickExclude);
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickExclude);
    },
};
